import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import Root from "./Root";


if (window.location.hostname !== 'localhost') {
  Sentry.init({dsn: process.env.REACT_APP_SENTRY_DSN_FOR_CLIENT})
}

ReactDOM.render(<Root/>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js